import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { About } from "@/components/About";
import { WhyChoose } from "@/components/WhyChoose";
import { Events } from "@/components/Events";
import { MenuShowcase } from "@/components/MenuShowcase";
import { Marquee } from "@/components/Marquee";
import { Signature } from "@/components/Signature";
import { LiveCounters } from "@/components/LiveCounters";
import { Gallery } from "@/components/Gallery";
import { HowItWorks } from "@/components/HowItWorks";
import { QuoteSection } from "@/components/QuoteSection";
import { LeadGenerator } from "@/components/LeadGenerator";
import { Testimonials } from "@/components/Testimonials";
import { ServiceArea } from "@/components/ServiceArea";
import { InstagramSection } from "@/components/InstagramSection";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="pb-14 md:pb-0">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <WhyChoose />
        <Events />
        <MenuShowcase />
        <Marquee />
        <Signature />
        <LiveCounters />
        <Gallery />
        <HowItWorks />
        <QuoteSection />
        <LeadGenerator />
        <Testimonials />
        <ServiceArea />
        <InstagramSection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
